import React, { useEffect, useState } from "react";
import axiosClient from "../../axios";

const DistributorApplications = () => {
  const [applications, setApplications] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchApplications();
  }, []);

  const fetchApplications = async () => {
    try {
      const response = await axiosClient.get("/api/distributor/applications");
      // Check both response.data and response.data.data (common Laravel patterns)
      setApplications(response.data?.data || response.data?.applications || []);
    } catch (err) {
      setError(err.response?.data?.message || "Failed to load applications");
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const updateStatus = async (id, status) => {
    try {
      await axiosClient.put(`/api/distributor/${id}/status`, { status });
      setApplications((prev) =>
        prev.map((app) => (app.id === id ? { ...app, status } : app))
      );
    } catch (err) {
      alert(err.response?.data?.message || "Failed to update status");
      console.error(err);
    }
  };

  if (loading) return <div className="p-4">Loading...</div>;
  if (error) return <div className="alert alert-danger">{error}</div>;

  return (
    <div className="container">
      <h2 className="mb-4">Distributors</h2>

      {/* Show empty state if no applications */}
      {!applications || applications.length === 0 ? (
        <div className="alert alert-info">
          No distributor applications found
        </div>
      ) : (
        <div className="table-responsive">
          <table className="table table-bordered align-middle">
            {/* Table headers remain the same */}
            <thead className="table-light">
              <tr>
                <th>#</th>
                <th>User</th>
                <th>Email</th>
                <th>Promotion Method</th>
                <th>Status</th>
                <th>Bank</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {applications.map((app, idx) => (
                <tr key={app.id}>
                  {/* Table rows remain the same */}
                  <td>{idx + 1}</td>
                  <td>{app.user?.name || "—"}</td>
                  <td>{app.user?.email || "—"}</td>
                  <td>{app.promotion_method || "—"}</td>
                  <td>
                    <span className={`badge bg-${getBadgeColor(app.status)}`}>
                      {app.status}
                    </span>
                  </td>
                  <td>
                    <div>
                      <strong>{app.bank_name || "—"}</strong>
                    </div>
                    <div>{app.bank_account_name || "—"}</div>
                    <div>{app.bank_account_number || "—"}</div>
                  </td>
                  <td>
                    {app.status === "pending" ? (
                      <>
                        <button
                          className="btn btn-success btn-sm me-2"
                          onClick={() => updateStatus(app.id, "active")}
                        >
                          Approve
                        </button>
                        <button
                          className="btn btn-danger btn-sm"
                          onClick={() => updateStatus(app.id, "rejected")}
                        >
                          Reject
                        </button>
                      </>
                    ) : (
                      <span className="text-muted">No actions</span>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

// getBadgeColor remains the same
const getBadgeColor = (status) => {
  switch (status) {
    case "active":
      return "success";
    case "pending":
      return "warning";
    case "rejected":
      return "danger";
    default:
      return "secondary";
  }
};

export default DistributorApplications;
